export const numeratorDataId = 'length-counter-numerator'
export const denominatorDataId = 'length-counter-denominator'

export const getSelectOption = (option: string) => {
  if (option.includes(':')) {
    const [value, text] = option.split(':').map((part) => part.trim())
    return { value, text }
  }
  return { value: option, text: option }
}
